module.exports = __webpack_public_path__ + "img/hr.f4018d22.svg";